import styled from "styled-components"

export default function PurchaseBtn({ ...rest }) {
  return <Button {...rest}>구매하기</Button>
}

const Button = styled.button`
  padding: calc(100vw * (18 / 375));
  width: 100%;
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (22 / 375));
  color: #000000;
  background-color: #ffcf19;
  border-radius: calc(100vw * (5 / 375));

  &:disabled {
    color: #989898;
    background-color: #d8d8d8;
  }
`
